import { ReactNode } from 'react'
import { YMaps } from '@pbe/react-yandex-maps'
import { getEnv } from 'helpers/common'

import { YMapsProps } from './types'

interface IProps {
  children?: ReactNode
}

const query: YMapsProps['query'] = {
  lang: 'ru_RU',
  apikey: getEnv('VITE_REACT_APP_YMAPS_LK_CODE'),
  coordorder: 'latlong'
}

export const MapProvider = ({ children }: IProps) => <YMaps query={query}>{children}</YMaps>
